<template>
  <!-- 计数器 -->
  <div class="input-number-container">
    <el-input :value="getValue" @input="updateValue" @change="disposeValue" :maxlength="5">
      <template slot="append">
        <div class="append-content">
          <div class="add" @click="add"></div>
          <div class="del" @click="del"></div>
        </div>
      </template>
    </el-input>
  </div>
</template>

<script>
export default {
  name: 'input-number',
  props: {
    value: [String, Number],
    suffix: {
      type: String,
      default: ''
    }
  },
  methods: {
    updateValue (value) {
      this.$emit('input', value)
    },
    disposeValue (value) {
      let disposeValue = this.getDisposeValue(value)
      if (this.suffix && String(disposeValue) !== '') {
        // 不管他有没有后缀，统一去除，最后在添加
        disposeValue = String(disposeValue).replace(new RegExp(`${this.suffix}`, 'g'), '')
      }
      this.$emit('input', String(disposeValue) !== '' ? disposeValue + this.suffix : '')
    },
    getDisposeValue (value) {
      let disposeValue = parseFloat(value)
      if (isNaN(disposeValue)) {
        disposeValue = ''
      }
      if (disposeValue < 0) {
        disposeValue = 0
      } else if (disposeValue > 100) {
        disposeValue = 100
      }
      return disposeValue
    },
    add () {
      let disposeValue = this.getDisposeValue(this.value)
      if (String(disposeValue) !== '') {
        if (disposeValue < 100) {
          disposeValue += 1
        }
      } else {
        disposeValue = 1
      }
      this.$emit('input', String(disposeValue) !== '' ? disposeValue + this.suffix : '')
    },
    del () {
      let disposeValue = this.getDisposeValue(this.value)
      if (String(disposeValue) !== '') {
        if (disposeValue > 0) {
          disposeValue -= 1
        }
      } else {
        disposeValue = 1
      }
      this.$emit('input', String(disposeValue) !== '' ? disposeValue + this.suffix : '')
    }
  },
  computed: {
    getValue () {
      return this.value
    }
  }
}
</script>

<style lang="scss">
  .input-number-container {
    .el-input {
      height: 24px;
      line-height: 24px;
      .el-input__inner {
        padding: 0;
        text-align: center;
        height: 24px;
        line-height: 24px;
      }
      .el-input-group__append {
        width: 13px;
        margin: 0;
        padding: 0;
        overflow: hidden;
        background-color: #F5F5F5;
        height: 24px;
        box-sizing: border-box;
        .append-content {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-direction: column;
          .add, .del {
            height: 11px;
            width: 100%;
            font-size: 10px;
            line-height: 13px;
            overflow: hidden;
            color: #C2C3C4;
            vertical-align: top;
            cursor: pointer;
          }
          .add {
            border-bottom: 1px solid #C2C3C4;
            box-sizing: border-box;
            background: url("../assets/images/add.png")no-repeat center;
          }
          .del {
            border-top: 1px solid transparent;
            background: url("../assets/images/del.png")no-repeat center;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/report/design/customPage/style-setting/input-number.vue